import {
  WebsiteDestinationPageDetailSchema,
  WebsiteDestinationPageListResponseSchema,
  DestinationPageCollectionCandidatesResponseSchema,
  type CreateWebsiteDestinationPageRequest,
  type DestinationPageCollectionCandidatesResponse,
  type UpdateWebsiteDestinationPageRequest,
  type WebsiteDestinationPageDetail,
  type WebsiteDestinationPageListQuery,
  type WebsiteDestinationPageListResponse,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

const BASE = '/admin/website/destination-pages';

export const list = async (
  query: WebsiteDestinationPageListQuery,
): Promise<WebsiteDestinationPageListResponse> => {
  const { data } = await apiClient.get<unknown>(BASE, { params: query });
  return WebsiteDestinationPageListResponseSchema.parse(data);
};

export const get = async (id: string): Promise<WebsiteDestinationPageDetail> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/${id}`);
  return WebsiteDestinationPageDetailSchema.parse(data);
};

export const create = async (
  payload: CreateWebsiteDestinationPageRequest,
): Promise<WebsiteDestinationPageDetail> => {
  const { data } = await apiClient.post<unknown>(BASE, payload);
  return WebsiteDestinationPageDetailSchema.parse(data);
};

export const update = async (
  id: string,
  payload: UpdateWebsiteDestinationPageRequest,
): Promise<WebsiteDestinationPageDetail> => {
  const { data } = await apiClient.patch<unknown>(`${BASE}/${id}`, payload);
  return WebsiteDestinationPageDetailSchema.parse(data);
};

export const remove = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};

export const publish = async (id: string): Promise<WebsiteDestinationPageDetail> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/${id}/publish`);
  return WebsiteDestinationPageDetailSchema.parse(data);
};

export const unpublish = async (id: string): Promise<WebsiteDestinationPageDetail> => {
  const { data } = await apiClient.post<unknown>(`${BASE}/${id}/unpublish`);
  return WebsiteDestinationPageDetailSchema.parse(data);
};

export const listCollectionCandidates = async (
  destinationId: string,
): Promise<DestinationPageCollectionCandidatesResponse> => {
  const { data } = await apiClient.get<unknown>(`${BASE}/collection-candidates`, {
    params: { destinationId },
  });
  return DestinationPageCollectionCandidatesResponseSchema.parse(data);
};
